import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  useDeleteTeamMutation,
  useGetTeamsListQuery,
} from "../../../store/teams/TeamsApiSlice";
import CustomButton from "../../../theme/style-components/CustomButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomIconBox from "../../../theme/style-components/CustomIconBox";
import CustomModal from "../../../theme/style-components/CustomModal";
import AddEntryModal from "../AddDepartmentAndTeam";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { selectCurrentUserObject } from "../../../store/auth/authSlice";

const Teams = () => {
  const userType = localStorage.getItem("userType");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [deleteTeam] = useDeleteTeamMutation();
  const user = useSelector(selectCurrentUserObject);

  const {
    isLoading: isTeamsLoading,
    data: TeamsData,
    error: isTeamsError,
    refetch: refetchTeamsData,
  } = useGetTeamsListQuery({
    org_id: user?.company},{ skip: !user?.company });

  const handleDeleteTeam = async () => {
    console.log("I am going to delete");
    try {
      const result = await deleteTeam(selectedTeam.id)
        .unwrap()
        .then((res) => {
          console.log(res, "res");
          toast.success("Team deleted successfully");
          // Reset and close modal
          refetchTeamsData();
          setIsDeleteModalOpen(false);
        });
    } catch (error) {
      toast.error(`Something went wrong!!`);
    }
  };

  return (
    <>
      <Box sx={{ display: "grid", gap: "15px" }}>
        <Box
          sx={{
            display: "flex",
            gap: "15px",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6" align="center" sx={{ fontSize: "18px" }}>
            Teams
          </Typography>
          {userType === "ADMIN" && (
            <Button
              type="button"
              color="primary"
              sx={{
                p: "8px 15px",
                background: "#1F6EB9",
                color: "#fff",
                lineHeight: "1",
                fontSize: "14px",
                fontWeight: "500",
                "&:hover": {
                  background: "#388edf",
                },
              }}
              onClick={() => {
                console.log("Add button clicked");
                setIsModalOpen(true);
              }}
            >
              {" "}
              + Add
            </Button>
          )}
        </Box>

        <Box>
          {isTeamsLoading ? (
            <Typography variant="h6" align="center">
              Loading...
            </Typography>
          ) : (
            <Typography
              variant="h6"
              sx={{ border: "1px solid #dfe3e8", borderTop: 0 }}
            >
              {TeamsData?.data.map((team) => (
                <Box
                  key={team.id}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                    alignItems: "center",
                    borderTop: "1px solid #dfe3e8",
                    padding: "10px 15px",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      m: 0,
                      p: 0,
                      lineHeight: "1",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  >
                    {team.name}
                  </Typography>
                  {/* <Typography>{team.description}</Typography> */}
                  {userType === "ADMIN" && (
                    <Box sx={{ display: "flex", gap: "10px", m: "0" }}>
                      <EditIcon
                        sx={{ width: "22px" }}
                        onClick={() => {
                          setSelectedTeam(team);
                          setIsEditModalOpen(true);
                        }}
                      />
                      <DeleteIcon
                        sx={{ width: "22px" }}
                        onClick={() => {
                          setSelectedTeam(team);
                          setIsDeleteModalOpen(true);
                        }}
                      />
                    </Box>
                  )}
                </Box>
              ))}
            </Typography>
          )}
        </Box>
      </Box>
      <CustomModal
        isModalOpen={isModalOpen}
        isShowActionButton= {false}
        handleClose={() => setIsModalOpen(false)}
        title={`Add Team`}
      >
        <AddEntryModal
          onClose={() => setIsModalOpen(false)}
          title={`Team`}
          refetchData={refetchTeamsData}
        />
      </CustomModal>
      <CustomModal
        isModalOpen={isEditModalOpen}
        isShowActionButton= {false}
        handleClose={() => setIsEditModalOpen(false)}
        title={`Edit Team`}
      >
        <AddEntryModal
          onClose={() => setIsEditModalOpen(false)}
          title={`Team`}
          refetchData={refetchTeamsData}
          selectedDepartment={selectedTeam}
          setSelectedDepartment={setSelectedTeam}
        />
      </CustomModal>
      <Dialog
        open={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        disableScrollLock
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            textAlign: "center",
            p: "35px 70px",
          }}
        >
          <DialogTitle
            sx={{ p: "0 0 10px !important" }}
          >{`Confirm Delete Team`}</DialogTitle>
          <DialogContent sx={{ p: "0 0 25px" }}>
            Are you sure you want to delete <br />
            <span style={{ fontWeight: "600" }}>
              {" "}
              {selectedTeam?.name}
            </span>{" "}
            department?
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              gap: "0",
              justifyContent: "center",
              p: "0",
            }}
          >
            <Button
              onClick={() => setIsDeleteModalOpen(false)}
              sx={{ textTransform: "none", color: "#333" }}
            >
              No
            </Button>
            <Button
              onClick={handleDeleteTeam}
              variant="contained"
              sx={{ textTransform: "none", background: "red" }}
            >
              Yes
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

export default Teams;
